import * as vp from 'vopay';
import { FunctionComponent, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InteracForm from './InteracForm';
import usePostAddInteracEmail from '../../../../hooks/useApi/usePostAddInteracEmail';
import styles from './InteracDialogue.module.scss';

const { Modal, ConfirmationDialogue } = vp;

export type DialogueProps = {
  onClose: () => void;
  onSuccess: (name: string, token: string) => void;
  isVisible: boolean;
};
type FC = FunctionComponent<DialogueProps>;

const Dialogue: FC = ({ onClose, onSuccess, isVisible }: DialogueProps) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Accounts.MyBankAccounts.InteracDialogue.InteracDialogue',
  });
  const [interacFormVisible, setInteracFormVisible] = useState(true);
  const [addInteracResponse, addInteracEmail, , resetInterac] = usePostAddInteracEmail({});
  const [requestValues, setRequestValues] = useState<vp.InteracAddEmailRequest>({
    RecipientName: '',
    ClientControlled: true,
    etransferConnectionType: 'email',
    RecipientEmailAddress: '',
    RecipientPhoneNumber: '',
    ClientReferenceNumber: '',
    Question: '',
    Answer: '',
    Nickname: '',
  });

  const handlers = {
    onCreateInterac: (params: vp.InteracAddEmailRequest) => {
      setRequestValues(params);
      setInteracFormVisible(false);
    },
    onClose: () => {
      onClose();
    },
  };
  useEffect(() => {
    if (addInteracResponse.Success) {
      onSuccess(requestValues.RecipientName, addInteracResponse.Token);
      resetInterac();
    }
  }, [addInteracResponse]);
  return (
    <>
      {isVisible && (
        <div>
          <Modal isVisible={interacFormVisible} enableBgClick={false}>
            <div className={styles.InteracFormContainer}>
              <InteracForm handlers={handlers} defaultValues={requestValues} />
            </div>
          </Modal>
          <ConfirmationDialogue
            isVisible={!interacFormVisible}
            title={t('addOperationalAccount')}
            status="none"
            subTitle={t('confirmInterac', {
              value:
                requestValues.etransferConnectionType === 'email'
                  ? requestValues.RecipientEmailAddress || ''
                  : requestValues.RecipientPhoneNumber || '',
            })}
            confirm={{
              label: t('addOperationalAccount'),
              action: () => {
                addInteracEmail(requestValues);
              },
            }}
            close={{
              action: () => {
                onClose();
              },
            }}
          />
        </div>
      )}
    </>
  );
};

export default Dialogue;
